import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { X_OTP } from 'src/app/app.constants';
import { EBillsRelationshipModel } from 'src/app/models/e-bills-relationship.model';
import { eBillsModel } from 'src/app/models/e-bills.model';
import { createHttpParams } from 'src/app/shared/utils/create-http-params.utils';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class EBillsService extends BaseService<eBillsModel> {
  constructor(protected http: HttpClient) {
    super(http, 'e-bills');
  }

  updateInvoiceStatus(
    paymentId: string,
    paymentStatus: string
  ): Observable<HttpResponse<any>> {
    return this.http.patch<any>(
      `${this.resourceUrl}/${paymentId}?paymentStatus=${paymentStatus}`,
      {
        observe: 'response'
      }
    );
  }
  getEBillDetails(paymentId: any) {
    return this.http.get<any>(`${this.resourceUrl}/${paymentId}`, {
      observe: 'response'
    });
  }

  getServices(searchValues: any) {
    const params = createHttpParams(searchValues);
    return this.http.get<any>(`${this.resourceUrl}/services`, {
      params,
      observe: 'response'
    });
  }

  getSubscribedList(searchValues: any) {
    const params = createHttpParams(searchValues);
    return this.http.get<any>(`${this.resourceUrl}/billing-relationships`, {
      params,
      observe: 'response'
    });
  }

  createNewBillingRelationship(
    relationshipModel: EBillsRelationshipModel
  ): Observable<HttpResponse<any>> {
    return this.http.post<any>(
      `${this.resourceUrl}/billing-relationship`,
      relationshipModel,
      {
        observe: 'response'
      }
    );
  }

  setBillingRelationshipDirectDebit(
    searchValues: any
  ): Observable<HttpResponse<any>> {
    return this.http.post<any>(
      `${this.resourceUrl}/billing-relationship/${searchValues}/direct-payment?enable=true`,
      {
        observe: 'response'
      }
    );
  }

  exportEBill(searchValues: any): Observable<HttpResponse<{ data: string }>> {
    const params = createHttpParams(searchValues);
    return this.http.get<{ data: string }>(
      `${this.resourceUrl}/${searchValues.paymentId}/download/${searchValues.attachmentId}`,
      {
        /* params, */
        observe: 'response'
      }
    );
  }

  uploadZipFolder(body: string): Observable<HttpResponse<eBillsModel>> {
    return this.http.post<eBillsModel>(
      `${this.resourceUrl}/upload-invoice`,
      body,
      {
        observe: 'response'
      }
    );
  }

  authorizeInvoice(
    entity: eBillsModel,
    data: string
  ): Observable<HttpResponse<eBillsModel>> {
    const headers = new HttpHeaders().set(X_OTP, data);
    return this.http.post<eBillsModel>(
      `${this.resourceUrl}/authorize-invoice`,
      entity,
      {
        headers,
        observe: 'response'
      }
    );
  }

  signInvoice(
    entity: eBillsModel,
    data: string
  ): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders().set(X_OTP, data);
    return this.http.post<any>(`${this.resourceUrl}/sign-invoice`, entity, {
      headers,
      observe: 'response'
    });
  }
}
